<template>
  <a-spin :spinning="loading">
    <a-row :gutter="16">
      <a-col :span="18">
        <div class="card">
          <div class="card-header">
            <h5><strong>Existing auction types</strong></h5>
          </div>
          <div class="card-body">
            <label for="">Existing auction types</label>
            <div style="text-align: center">
              <a-table
                :columns="columns"
                :data-source="dataSource"
                :pagination="{ pageSize: 50 }"
                :row-key="(record) => record.id"
              >
                <span slot="actions" slot-scope="record">
                  <a-space :space="16">
                    <a-popconfirm
                      title="Are you sure you want to swap status of this auction type?"
                      ok-text="Yes"
                      cancel-text="No"
                      @confirm="swapStatus(record.id)"
                      ><a
                        ><i
                          class="fe fe-repeat font-size-15 align-middle text-gray-6"
                          title="Change status"
                      /></a>
                    </a-popconfirm>

                    <a-popconfirm
                      title="Are you sure you want to delete this auction type?"
                      ok-text="Yes"
                      cancel-text="No"
                      @confirm="deleteAuctionType(record.id)"
                      ><a
                        ><i
                          class="fe fe-trash font-size-15 align-middle text-gray-6"
                          title="Delete"
                      /></a>
                    </a-popconfirm>
                  </a-space>
                </span>

                <span slot="active" slot-scope="text">
                  <a-tag :color="text === 0 ? 'volcano' : 'green'">
                    {{ text === 0 ? 'INACTIVE' : 'ACTIVE' }}
                  </a-tag>
                </span>
              </a-table>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="card">
          <div class="card-header">
            <h5><strong>Add new auction type</strong></h5>
          </div>
          <div class="card-body">
            <a-form-item label="Auction type name">
              <a-input v-model="name" style="width: 100%"></a-input>
            </a-form-item>
            <a-form-item>
              <a-button
                class="btn btn-success btn-block"
                @click="addAuctionType"
                ><i
                  class="fe fe-plus-circle font-size-15"
                  title="Add participant"
                  style="margin-right: 10px"
                />
                Add new auction type
              </a-button>
            </a-form-item>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
import Vue from 'vue'
import { Space } from 'ant-design-vue'
Vue.use(Space)
import { AuctionTypesService } from '@/services/api'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',

    width: '65%',
  },
  {
    title: 'Status',
    dataIndex: 'active',
    scopedSlots: { customRender: 'active' },
    width: '20%',
  },
  {
    title: 'Actions',
    scopedSlots: { customRender: 'actions' },
    align: 'center',
    width: '15%',
  },
]

export default {
  components: {},
  data() {
    return {
      columns: columns,
      dataSource: [],
      name: null,
      loading: false,
    }
  },
  methods: {
    swapStatus(id) {
      AuctionTypesService.swapActive(id).then((response) => {
        this.getAuctionTypes()
      })
    },
    deleteAuctionType(id) {
      AuctionTypesService.delete(id).then((response) => {
        this.getAuctionTypes()
      })
    },
    addAuctionType() {
      if (!this.name || this.name.length < 2) {
        this.$notification.error({
          message: 'Unesite naziv',
          description: `Unesite naziv tipa aukcije.`,
        })
        return
      }
      var dataToSend = {
        name: this.name,
      }
      this.name = null
      AuctionTypesService.save(dataToSend).then((response) => {
        this.getAuctionTypes()
      })
    },
    getAuctionTypes() {
      AuctionTypesService.get().then((response) => {
        console.log(response.data.data)
        this.dataSource = response.data.data
      })
    },
  },
  mounted() {
    this.getAuctionTypes()
  },
}
</script>
